// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamAggregatorResponseDto
 */
export interface IClaimsTeamAggregatorResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamAggregatorResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamAggregatorResponseDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IClaimsTeamAggregatorResponseDto interface.
 */
export function instanceOfIClaimsTeamAggregatorResponseDto(value: object): value is IClaimsTeamAggregatorResponseDto {
    return true;
}

export function IClaimsTeamAggregatorResponseDtoFromJSON(json: any): IClaimsTeamAggregatorResponseDto {
    return IClaimsTeamAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IClaimsTeamAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IClaimsTeamAggregatorResponseDtoToJSON(json: any): IClaimsTeamAggregatorResponseDto {
    return IClaimsTeamAggregatorResponseDtoToJSONTyped(json, false);
}

export function IClaimsTeamAggregatorResponseDtoToJSONTyped(value?: IClaimsTeamAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

